import Vue from 'vue';
import EcommerceOrder from '@/plugins/graphql/queries/v2/order.gql';
import { OrderFullModel } from '@/helpers/entities/models/OrderFullModel';
/**
 * Component for fetching Order Details
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version 0.1.16
 */
export default Vue.extend({
    apollo: {
        order: {
            query: EcommerceOrder,
            variables() {
                return {
                    orderUuid: this.orderUuid,
                };
            },
            update(data) {
                return new OrderFullModel(data.ecommerceOrder);
            },
        },
    },
    props: {
        /**
         * Order UUID Prop
         * @author Peter John Alvarado <peterjohn@gorated.ph>
         * @since Version 0.1.16
         */
        orderUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            order: null,
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                order: this.order,
            });
        }
    },
});
